import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_paper.gif';
import type { ItemPaper } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';
import PaperUtil from './PaperUtil';

class PaperList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Paper';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemPaper;
        const authors = item.author.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {authors}
                <br />
                {Functions.mlang(item.journal, lang)}
                {item.publication_year}
                {item.volume !== null && ` ;${item.volume}`}
                {item.number !== null && ` (${item.number})`}
                {item.page !== '' && ` :${item.page}`}
                {item.pubmed_id !== '' && (
                    <>
                        {' '}
                        [PMID:
                        <PaperUtil.PubmedLink lang={lang} pubmedId={item.pubmed_id} />]
                    </>
                )}
            </>
        );
    }
}

export default PaperList;
